import * as React from 'react'

export interface Props {
  onSelectPhoto?: (photo: string) => void
  onViewDialogue?: () => void
  onViewInformation?: () => void
}

export default class ToolBar extends React.Component<Props> {
  private fileInput: any

  render () {
    return (
      <div
        className='absolute left-0 right-0 bottom-0 bg-silver'
        style={{ height: '50px', zIndex: 10000 }}>
        <div
          style={{ maxWidth: '1000px', height: '100%' }}
          className='mx-auto flex items-center justify-around'>
          <button
            className='btn'
            title='Post a photo'
            onClick={this.onPhotoClick}>
            <input
              type='file'
              accept='.jpg,.jpeg'
              className='display-none'
              onChange={this.onFileInputChange}
              ref={this.onFileInputRef}
            />
            <i className='fa fa-picture-o' />
          </button>
          <button className='btn' onClick={this.onViewDialogue}>
            <i className='fa fa-comments' title='View dialogue' />
          </button>
          <button className='btn' onClick={this.onViewInformation}>
            <i className='fa fa-info-circle' title='Infomation' />
          </button>
        </div>
      </div>
    )
  }

  private onPhotoClick = () => {
    this.fileInput.click()
  }

  private onFileInputRef = (fileInput: any) => {
    this.fileInput = fileInput
  }

  private onFileInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const reader = new FileReader()
    reader.onload = (event: any) => {
      if (this.props.onSelectPhoto) {
        this.props.onSelectPhoto(event.target.result)
      }
    }
    reader.readAsDataURL(event.target.files![0])
    event.target.value = ''
  }

  private onViewDialogue = () => {
    if (this.props.onViewDialogue) {
      this.props.onViewDialogue()
    }
  }

  private onViewInformation = () => {
    if (this.props.onViewInformation) {
      this.props.onViewInformation()
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Toolbar.tsx